export class ContactFormRequestModel {
    fullName;
    email;
    telephoneNumber;
    message;
    captchaResponse;
}